<template>
  <div
    class="t-td"
    :style="{
			'min-width': width + 'px',
			'border-left-width': borderType === 'grid' ? '1px' : '0',
			'border-bottom-width': borderType === 'none' ? '0' : '1px',
			'border-color' : borderColor,
			'justify-content': tdAlignCpd
		}"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
		align: {
			type: String,
			default: 'center'
		},
		width: {
			type: String,
			default: undefined
		}
  },
  data() {
    return {
			borderColor: '#e4e4e4',
			borderType: 'grid',
      tdAlign: "center"
    };
  },
  inject: ["table", "tr"],

  created() {
		this.borderColor = this.table.borderColor;
		this.borderType = this.table.borderType;
    if (this.tr.align) {
      this.tdAlign = this.tr.align;
    } else {
      this.tdAlign = this.align;
    }
  },
  computed: {
    tdAlignCpd() {
      let nameAlign = "";
      switch (this.tdAlign) {
        case "left":
          nameAlign = "flex-start";
          break;
        case "center":
          nameAlign = "center";
          break;
        case "right":
          nameAlign = "flex-end";
          break;
        default:
          nameAlign = "center";
          break;
      }
      return nameAlign;
    }
  }
};
</script>

<style>
.t-td {
  flex: 1;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 10px;
  border-bottom: 1px #e4e4e4 solid;
	border-left: 1px #e4e4e4 solid;
  text-align: center;
  color: #555c60;
  font-size: 14px;
}
</style>